import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reportsPost } from "../../store/reports/actions";

export const useApiPostReports = (trigger: boolean, reportBody: any) => {
  const dispatch = useDispatch();

  const { loadingReports, responseReports, errorReports } = useSelector(
    (state: any) => ({
      loadingReports: state.Reports.loadingReports,
      responseReports: state.Reports.responseReports?.data,
      errorReports: state.Reports.errorReports,
    }),
  );

  useEffect(() => {
    if (trigger) {
      dispatch(reportsPost(reportBody));
    }
  }, [trigger, reportBody]);

  return {
    loadingReports,
    responseReports,
    errorReports,
  };
};
